module.exports = import("https://esm.sh/double-metaphone@2");;